<template>
    <p class="arm-info arm-info-italic" v-if="!envARLDE">
        {{ engagement }} s'engage à ne pas divulguer ni vendre vos données personnelles à des partenaires tiers. Vous
        disposez d'un droit d'accès, de rectification, d'opposition,
        de limitation du traitement, d'effacement et de portabilité de vos données personnelles, dans les
        conditions prévues au Règlement Général sur la Protection des Données.
    </p>
    <p class="arm-info arm-info-italic" v-else-if="envARLDE">
        {{ engagement }} verpflichtet sich, Ihre persönlichen Daten nicht an dritte Partner weiterzugeben oder zu verkaufen. Sie haben gemäß der Datenschutzverordnung das Recht auf Zugriff, Änderung, Löschung sowie Einschränkung der Verwendung und der Übertragbarkeit Ihrer personenbezogenen Daten.
    </p>
</template>

<script>

export default {
    name: 'EngagementRGPD',
    props: {
        engagement : String,
        envARLDE: Boolean
    }
}

</script>